<template>
  <div
    class="rank_division_picker d-flex-column justify-start align-start"
    :key="type"
  >
    <div
      class="d-flex-column justify-start align-start rank_picker_area"
      :class="selectedRank.class"
    >
      <div class="d-flex-row justify-start gap-18">
        <img
          :src="selectedRank.image"
          :alt="selectedRank.title + ' - Selected game rank image'"
          class="selected_rank_image"
        />

        <div class="d-flex-column align-start gap-0">
          <h4 class="font-family-1 title-h5 f-w-600">{{ title }}</h4>
          <p class="rank-title regular-xl font-family-2 rank_title">
            {{ selectedRank.title }}
          </p>
        </div>
      </div>

      <div class="rank_picker_container valorant">
        <rank-picker
          v-for="gameRank in ranks"
          :rank-image="gameRank.image_dark"
          :rank-title="gameRank.title"
          :rank="gameRank"
          :select-rank="selectRank"
          :is-selected="isRankSelected(gameRank.id)"
          :is-disabled="isRankDisabled(gameRank.id)"
        />
      </div>
      <div class="d-flex-row" v-if="divisions.length > 1">
        <svg
          width="29"
          height="1"
          viewBox="0 0 29 1"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="29" height="1" fill="#17181A" />
        </svg>
      </div>

      <div class="division_picker_container valorant">
        <division-picker
          v-for="division in divisions"
          :division-title="division.title"
          :select-division="selectDivison"
          :division="division"
          :is-selected="isDivisionSelected(division.id)"
          :is-disabled="isDivisionDisabled(division.id)"
        />
      </div>
      <value-setter
        v-if="getDetails[type] === 18"
        v-model="rankNumber"
        :min="min"
      />
    </div>

    <div
      class="d-flex-row md-row-to-col"
      style="padding: 0 18px 18px 18px"
      v-if="showServer || showrrGain"
    >
      <drop-down
        :label="$t('missed.rr_gain')"
        :item-key="'rrGain'"
        v-if="showrrGain"
        :drop-items="keyedRRGain"
        :placeholder="'RR Gain'"
        :select-drop-item="selectItem"
        :selected-item="getPackExtraOptions['rrGain']"
      />
      <drop-down
        v-if="showServer"
        :label="$t('missed.server')"
        placeholder="Select Server"
        item-key="server"
        :drop-items="keyedServers"
        :select-drop-item="selectItem"
        :selected-item="getSelectedServer?.value"
      />
    </div>
  </div>
</template>

<script>
import RankPicker from "../../commonpickers/RankPicker.vue";
import DivisionPicker from "../../commonpickers/DivisionPicker.vue";
import ValueSetter from "../../commonpickers/ValueSetter.vue";
import DropDown from "../../../custom/DropDown.vue";

export default {
  data() {
    return {
      rankNumber: 0,
    };
  },

  props: {
    type: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    itemKey: {
      type: String,
      default: "",
    },
    prevRank: {
      default: {},
    },
    showServer: {
      type: Boolean,
      default: false,
    },
    showrrGain: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    RankPicker,
    DivisionPicker,
    ValueSetter,
    DropDown,
  },

  methods: {
    selectRank(rank) {
      const details = this.getDetails;

      const divisonType =
        this.type === "currentRank" ? "currentDivision" : "desiredDivision";

      const titleKey =
        this.type === "currentRank" ? "currentRankTitle" : "desiredRankTitle";

      const divisionTitleKey =
        this.type === "currentRank"
          ? "currentDivisionTitle"
          : "desiredDivisionTitle";

      this.setDetails({
        ...details,
        [this.type]: rank.id,
        [titleKey]: rank.title,
        [divisonType]: rank.divisions[0]?.id || null,
        [divisionTitleKey]: rank.divisions[0]?.title || "",
      });

      if (rank.title === "Immortal") {
        this.handleLp();
      } else if (this.type === "desiredRank") {
        delete this.getDetails["desiredRankLp"];
      } else if (this.type === "currentRank") {
        delete this.getDetails["currentRankLp"];
      }

      if (this.type === "currentRank" && this.itemKey === "rankBoosting") {
        this.handleNextRankDivision(rank.id, rank.divisions[0]?.id);
      }
    },
    selectDivison(division) {
      const details = this.getDetails;
      const type =
        this.type === "currentRank" ? "currentDivision" : "desiredDivision";

      const divisionTitleKey =
        this.type === "currentRank"
          ? "currentDivisionTitle"
          : "desiredDivisionTitle";
      this.setDetails({
        ...details,
        [type]: division.id,
        [divisionTitleKey]: division.title || "",
      });

      if (this.type === "currentRank" && this.itemKey === "rankBoosting") {
        this.handleNextRankDivision(this.getDetails[this.type], division.id);
      }
    },

    updateRank() {},

    isRankSelected(rank) {
      return this.getDetails[this.type] === rank;
    },

    isRankDisabled(rankId) {
      if (!this.prevRank) {
        return false;
      }
      if (this.type === "currentRank") return false;
      return rankId < this.checkoutStore.getDetails.currentRank;
    },

    isDivisionSelected(divisionId) {
      if (this.type === "currentRank") {
        return this.getDetails.currentDivision === divisionId;
      } else if (this.type === "desiredRank") {
        return this.getDetails.desiredDivision === divisionId;
      }
    },

    isDivisionDisabled(divisionId) {
      if (!this.prevRank || this.type === "currentRank") {
        return false;
      }
      if (
        this.checkoutStore.getDetails.currentRank !==
        this.checkoutStore.getDetails[this.type]
      ) {
        return false;
      } else if (divisionId <= this.checkoutStore.getDetails.currentDivision) {
        return true;
      }
    },
    handleNextRankDivision(rankId, divisionId) {
      if (!this.itemKey === "rankBoosting") {
        return;
      }
      if (this.getDetails.currentRank < this.getDetails.desiredRank) {
        return;
      }

      const rankIndex = this.gameStore.getGameRanks.findIndex(
        (rnk) => rnk.id === rankId
      );

      const rank = this.gameStore.getGameRanks.find(
        (gameRank) => gameRank.id === rankId
      );

      const divisionIndex = rank?.divisions.findIndex(
        (div) => div.id === divisionId
      );

      const details = this.getDetails;

      const desiredDivisionIndex = rank?.divisions.findIndex(
        (div) => div.id === details.desiredDivision
      );
      if (divisionIndex !== rank?.divisions.length - 1) {
        let nextDivision = rank.divisions[divisionIndex + 1];
        const desiredRankDivision = rank.divisions[desiredDivisionIndex];

        if (nextDivision.id < desiredRankDivision?.id) {
          nextDivision = desiredRankDivision;
        }
        if (rank.title === "Immortal") {
          this.handleLp();
        }
        this.setDetails({
          ...details,
          desiredDivision: nextDivision.id,
          desiredRank: rankId,
          desiredRankTitle: rank.title,
          desiredDivisionTitle: nextDivision?.title || "",
        });
      } else {
        const index =
          rankIndex === this.gameStore.getGameRanks.length - 1
            ? rankIndex
            : rankIndex + 1;
        const nextRank = this.gameStore.getGameRanks[index];

        if (nextRank.title === "Immortal") {
          this.handleLp();
        }
        this.setDetails({
          ...details,
          desiredDivision: nextRank?.divisions[0]?.id || null,
          desiredRankTitle: nextRank.title,
          desiredDivisionTitle: nextRank?.divisions[0]?.title || "",
          desiredRank: nextRank.id,
        });
      }
    },
    selectItem(key, value) {
      if (key === "server") {
        this.setServer(value);
        return;
      }
      this.setPackExtraOptions({
        [key]: parseInt(value),
      });
    },

    handleLp() {
      if (
        this.getDetails.currentRankTitle === "Immortal" &&
        this.type === "currentRank" &&
        this.itemKey === "rankBoosting"
      ) {
        const desired = this.getDetails?.desiredRankLp || 0;
        const difference = desired - this.rankNumber;
        const lp =
          difference < 20
            ? this.rankNumber + 20
            : this.getDetails?.desiredRankLp;
        this.setDetails({
          ...this.getDetails,
          currentRankLp: this.rankNumber,
          desiredRankLp: lp,
        });
      } else if (
        this.getDetails.currentRankTitle === "Immortal" &&
        this.type === "currentRank" &&
        this.itemKey !== "rankBoosting"
      ) {
        this.setDetails({
          ...this.getDetails,
          currentRankLp: this.rankNumber,
        });
      } else if (
        this.type === "desiredRank" &&
        this.getDetails.desiredRankTitle === "Immortal"
      ) {
        const difference =
          this.getDetails?.desiredRankLp - this.getDetails?.currentRankLp;
        const lp =
          difference < 20
            ? this.getDetails?.currentRankLp + 20
            : this.rankNumber;
        this.setDetails({
          ...this.getDetails,
          desiredRankLp: lp,
        });
      }
    },
  },

  computed: {
    ranks() {
      if (this.itemKey !== "placementBoost") {
        const ar = [...this.gameStore.getGameRanks].slice(1);
        return ar;
      }
      return this.gameStore.getGameRanks;
    },
    divisions() {
      if (this.getDetails[this.type]) {
        const rankId = this.getDetails[this.type];
        const rank = this.gameStore.getGameRanks.find(
          (gameRank) => gameRank.id === rankId
        );
        return rank?.divisions || [];
      }
      return [];
    },
    selectedRank() {
      if (this.getDetails[this.type]) {
        const rank = this.gameStore.getGameRanks.find(
          (rank) => rank.id === this.getDetails[this.type]
        );
        const type =
          this.type === "currentRank" ? "currentDivision" : "desiredDivision";
        let divisionTitle = "";
        if (this.getDetails[type]) {
          const division = rank?.divisions.find(
            (div) => div.id === this.getDetails[type]
          );
          divisionTitle = division?.title;
        }
        return {
          image: rank?.image_dark,
          title: `${rank?.title} ${divisionTitle}`,
          class: `${this.currentGameSlug}-${rank?.title?.toLowerCase()}`,
        };
      }
      return {
        image: this.blankImage,
        title: "",
        class: "",
      };
    },
    keyedServers() {
      const servers = this.getGame?.servers || [];
      if (!servers) {
        return [];
      }
      return servers.reduce((acc, value) => {
        return { ...acc, [value.id]: value.title };
      }, {});
    },
    min() {
      if (
        this.getDetails.currentRankTitle === "Immortal" &&
        this.type === "desiredRank"
      ) {
        return this.getDetails.currentRankLp + 20;
      }
      return 0;
    },
    keyedRRGain() {
      const rrGain = this.getGamePack?.pack_extra_options?.filter(
        (option) => option.description === "rrGain"
      );

      if (!rrGain) {
        return [];
      }

      return rrGain.reduce((acc, value) => {
        return { ...acc, [value.id]: value.title };
      }, {});
    },
  },
  watch: {
    rankNumber() {
      this.handleLp();
    },
    "getDetails.desiredRankLp"() {
      if (this.type === "desiredRank") {
        this.rankNumber = this.getDetails.desiredRankLp || 0;
      }
    },
  },

  setup() {
    const gameStore = useGameStore();
    const { getGame, getGamePack } = gameStore;
    const { currentGameSlug } = useGameComposable();
    const checkoutStore = useCheckoutStore();
    const {
      getDetails,
      setDetails,
      getPackExtraOptions,
      setPackExtraOptions,
      getSelectedServer,
      setServer,
    } = checkoutStore;
    const blankImage =
      "data:image/png;base64,R0lGODlhFAAUAIAAAP///wAAACH5BAEAAAAALAAAAAAUABQAAAIRhI+py+0Po5y02ouz3rz7rxUAOw==";
    return {
      getGame,
      getGamePack,
      getDetails,
      setDetails,
      getPackExtraOptions,
      setPackExtraOptions,
      getSelectedServer,
      setServer,
      blankImage,
      currentGameSlug,
      gameStore,
      checkoutStore,
    };
  },
};
</script>
